import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import App from './App.jsx';
import i18n from './services/i18n.js';
import 'remixicon/fonts/remixicon.css';
import './assets/css/main.css';
import './services/sentry.js';
import { AuthProvider } from './context/AuthContext.jsx';
import { LanguageProvider } from './context/LanguageContext.jsx';
import { HistoryProvider } from './context/HistoryContext.jsx';

// Initial document language setup
document.documentElement.lang = i18n.language;

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
	<StrictMode>
		<AuthProvider>
			<I18nextProvider i18n={i18n}>
				<LanguageProvider>
					<HistoryProvider>
						<Suspense>
							<App />
						</Suspense>
					</HistoryProvider>
				</LanguageProvider>
			</I18nextProvider>
		</AuthProvider>
	</StrictMode>,
);
